import { Star } from 'lucide-react';

export const StarRating = ({ 
  rating, 
  size = 'md', 
  interactive = false, 
  onRatingChange = null,
  showValue = false 
}) => {
  const sizes = {
    sm: 'w-3 h-3',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  };

  const handleClick = (value) => {
    if (interactive && onRatingChange) {
      onRatingChange(value);
    }
  };

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => handleClick(star)}
          disabled={!interactive}
          className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'}`}
          data-testid={`star-${star}`}
        >
          <Star
            className={`${sizes[size]} ${
              star <= rating 
                ? 'fill-[#D4AF37] text-[#D4AF37]' 
                : 'fill-transparent text-[#A1A1AA]'
            } transition-colors`}
          />
        </button>
      ))}
      {showValue && (
        <span className="ml-2 text-sm font-medium text-[#D4AF37]">
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
};

export default StarRating;
